/**
 * Has common store components for Leaves report, its PDF export etc
 */
import BaseReportStore from '../BaseReportStore'
import $ from 'jquery'

class LeavesReportStore extends BaseReportStore {
    constructor() {
        super()
        this.showAssignedOnlyEnabled = false
        this.showAssignedOnly = false
        this.viewerInfo = null
        this.chartSectionConfig = {
            showChart: false
        }
        this.manageableUserIds = []
        this.reportAuthorizationInfo = {}
    }

    setReportAuthorizationInfo(reportAuthorizationInfo) {
        this.reportAuthorizationInfo = reportAuthorizationInfo
    }

    getReportAuthorizationInfo() {
        return this.reportAuthorizationInfo
    }

    setManageableUserIds(manageableUserIds) {
        this.manageableUserIds = manageableUserIds
    }

    getManageableUserIds() {
        return this.manageableUserIds
    }

    isShowAssignedOnlyEnabled() {
        return this.showAssignedOnlyEnabled
    }

    setShowAssignedOnlyEnabled(showAssignedOnlyEnabled) {
        this.showAssignedOnlyEnabled = showAssignedOnlyEnabled
    }

    getViewerInfo() {
        return this.viewerInfo
    }

    setViewerInfo(viewerInfo) {
        this.viewerInfo = viewerInfo
    }

    isShowAssignedOnly() {
        return this.showAssignedOnly
    }

    setShowAssignedOnly(showAssignedOnly) {
        this.showAssignedOnly = showAssignedOnly
    }

    getChartSectionConfig() {
        return this.chartSectionConfig
    }

    setChartSectionConfig(chartSectionConfig) {
        this.chartSectionConfig = chartSectionConfig
        $(this).trigger("chartSectionConfigChange")
    }

    getDefaultWorkDayDuration() {
        return this.defaultWorkDayDuration
    }

    setDefaultWorkDayDuration(defaultWorkDayDuration) {
        this.defaultWorkDayDuration = defaultWorkDayDuration
    }

    mergeGeneralStore(generalStore) {
        if (!this.groupingData.USER) this.groupingData.USER = {}
        mergeArrayToNullableMap(this.groupingData.USER, generalStore.getVisibleUsers())
        if (!this.groupingData.USER_GROUP) this.groupingData.USER_GROUP = {}
        mergeArrayToNullableMap(this.groupingData.USER_GROUP, generalStore.getUserGroups())
        if (!this.groupingData.TIME_ZONE_GROUP) this.groupingData.TIME_ZONE_GROUP = {}
        mergeArrayToNullableMap(this.groupingData.TIME_ZONE_GROUP, generalStore.getTimeZoneGroups())

        generalStore.getReportAuthorizationInfo && this.setReportAuthorizationInfo(generalStore.getReportAuthorizationInfo())
        generalStore.getManageableUserIds && this.setManageableUserIds(generalStore.getManageableUserIds())
    }
}

const store = new LeavesReportStore()
export default store


// WEBPACK FOOTER //
// ./web/js/reports/leavesReport/LeavesReportStore.js